import ClientInfantPassengerInterface from '../../interfaces/client/InfantPassenger'

import dateFromFrontEndToBackEndFormat from '../../utils/dates/dateFromFrontEndToBackEndFormat'

export const dateOfBirth = (infant: ClientInfantPassengerInterface) =>
  dateFromFrontEndToBackEndFormat(infant.dateOfBirth)

export default {
  dateOfBirth,
  firstName: 'firstName',
  gender: 'gender',
  id: 'id',
  lastName: 'lastName',
}
